/** @jsxImportSource @emotion/react */

import { Alert } from '@mui/material'
import { Fragment, ReactElement } from 'react';

type Props = {
  children: string
}

function ComponentError(props: Props): ReactElement {
  const children = props.children
  return (
    <Fragment>
      <Alert severity="error" sx={{ margin: 2 }}>
        {children}
      </Alert>
    </Fragment>
  )
}

export default ComponentError
